"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRadioStyles = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../../style/commons/_colors");
var hoverStyles = {
    '&:hover': {
        backgroundColor: _colors_1.secondaryHover,
    },
};
exports.useRadioStyles = (0, core_1.makeStyles)(function () { return ({
    root: tslib_1.__assign(tslib_1.__assign({}, hoverStyles), { width: 36, height: 36, '&$checked': tslib_1.__assign(tslib_1.__assign({}, hoverStyles), { color: _colors_1.darkPrimary }), background: 'none' }),
    checked: {
        color: _colors_1.darkPrimary,
    },
    controlLabel: {},
    colorPrimary: {
        color: _colors_1.darkPrimary,
    },
    disabled: { color: _colors_1.textInputColor },
    label: {
        color: _colors_1.darkPrimary,
        fontSize: 14,
        lineHeight: '18px',
        '&$disabled': {
            color: _colors_1.textInputColor,
        },
    },
}); });
